module["exports"] = [
  "SARL",
  "SA",
  "EURL",
  "SAS",
  "SEM",
  "SCOP",
  "GIE",
  "EI"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/company/suffix.js
// module id = 996
// module chunks = 0